/**
 * Upload persisted keepsake images for memorial product requests (Wave 4B).
 */
import axios from 'axios';
import { getApiBase } from './apiBase';

const API = getApiBase();

export async function uploadKeepsakeImage(memorialId, file) {
  const form = new FormData();
  form.append('memorial_id', memorialId);
  form.append('file', file);
  const { data } = await axios.post(`${API}/memorial-product-requests/keepsake-image`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function refreshKeepsakeImagePreview(memorialId, { uploadedImageKey, uploadedImageUrl }) {
  const params = { memorial_id: memorialId };
  if (uploadedImageKey) params.uploaded_image_key = uploadedImageKey;
  if (uploadedImageUrl) params.uploaded_image_url = uploadedImageUrl;
  const { data } = await axios.get(`${API}/memorial-product-requests/keepsake-image/preview`, { params });
  return data;
}
